import React, { useEffect, useState } from "react";
import "./HandList.scss";
import {
  Table
} from "react-bootstrap";
import i18n from "i18next";

function HandList({ match, history }) {
  const [games, setGames] = useState([
    {
      id: 1,
      name: "Pour la Daronne"
    }
  ]);

  useEffect(() => {
    console.log("bridge is", window.handBridge);
    let timer = null;
    if (window.handBridge) {
      let str = window.handBridge.getSessionList(-1, -1);
      console.log("bridge data", str);
      setGames(JSON.parse(str));
    } else {
      timer = setInterval(() => {
        if (window.handBridge) {
          let str = window.handBridge.getSessionList(-1, -1);
          console.log("bridge data", str);
          setGames(JSON.parse(str));
          clearInterval(timer);
        }
      }, 100);
    }
    return () => {
      if (timer) {
        clearInterval(timer);
      }
      console.log("session list effect done");
    };
  }, [match]);
  return (
    <Table striped bordered hover id="session-list">
      <thead>
        <tr>
          <th>Room</th>
          <th>Name</th>
          <th>Date</th>
          <th>Username</th>
        </tr>
      </thead>
      <tbody>
        {games.map((game) => (
          <tr key={game.id}>
            <td>{game.roomType}</td>
            <td>{game.name}</td>
            <td>
              {new Intl.DateTimeFormat(i18n.language, {
                year: "numeric",
                month: "short",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit"
              }).format(game.startDate)}
            </td>
            <td>-</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
export default HandList;
